import React from 'react';
var SidebarContext = /*#__PURE__*/React.createContext(null);
export default SidebarContext;